module.exports = __webpack_public_path__ + "static/ro-workshops-11-91df2be75051a70fdf6d553c4174aff6.jpg";